<template>
	<div class="sf-datatable-container">
		<div style="width: 450px">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--총합계 -->
							<th class="col-1" colspan="2">{{ rpymAmt.dcsnMm }} {{ getMessage_('QWCC001878') }}</th>
						</tr>
						<tr>
							<!--변제 -->
							<th class="col-1">{{ getMessage_('QWCC001373') }}</th>
							<td class="col-1">{{ rpymAmt.sumAplRpymAmt01 }}</td>
						</tr>
						<tr>
							<!--이의처리 -->
							<th class="col-1">{{ getMessage_('QWCC002043') }}</th>
							<td class="col-1">{{ rpymAmt.sumAplRpymAmt02 }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	data() {
		return {};
	},
	props: {
		scrId: { type: String, default: '' }
	},

	async created() {
		// this.$sf_toggleLoading(true);
		// this.getRepayMst_()
		// 	.catch(error => {
		// 		this.$sf_toast({
		// 			type: 'error',
		// 			message: error.message
		// 		});
		// 		Promise.reject(error);
		// 	})
		// 	.finally(() => {
		// 		this.$sf_toggleLoading(false);
		// //	});
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods
		// onChangeSelect(value, key) {
		// 	this.setRpymAmt_({ key, value });
		// }
		// async onGoPwaApcn() {
		// 	const name = this.getMessage_('QWCC000949');

		// 	let item = {
		// 		name,
		// 		component: PwaApcn, //import할 컴포넌트 이름
		// 		scrId: this.pwaApcnScrId, //이동할 scr
		// 		msgKey: 'QWCC000949'
		// 	};

		// 	await this.getScreen_({ scrId: item.scrId });
		// 	await this.$sf_removeTab(item.scrId);
		// 	await this.$sf_addTab(item, item.scrId, { scrId: item.scrId });
		// }
	}
};
</script>
